import React, { useEffect, useState } from "react";
import TrustedCompanies from "../../components/TrustedCompanies";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import styles from "./AboutUs.module.css";

export default function AboutUs() {
  const [t, i18n] = useTranslation("global");
  const [aboutData, setAboutData] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

    const [bgImage, setBgImage] = useState("");
  
      useEffect(() => {
        const fetchSettings = async () => {
          try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/setting`);
            const result = await response.json();
            if (result?.data[0]?.image_courses) {
              setBgImage(result.data[0].image_courses);
            }
          } catch (error) {
            console.error("Error fetching settings:", error);
          }
        };
    
        fetchSettings();
      }, []);
      
  useEffect(() => {
    const fetchAboutData = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/about_us`, {
          headers: {
            "Accept-Language": i18n.language,
          },
        });
        const result = await response.json();
        if (result && result.data && result.data.length > 0) {
          setAboutData(result.data[0]);
        }
      } catch (error) {
        console.error("Failed to fetch about data:", error);
      }
    };

    fetchAboutData();
  }, [i18n.language]);

  return (
    <>
        <div className={`${styles.aboutHero} custom-section`} style={{
        backgroundImage: `url(${bgImage})`,
      }}>
        <div className="container">
          <div className={styles.heroContent}>
            <h1 className={`${styles.heroTitle} mb-1`}>{t("about.title")}</h1>
            <h6 className={styles.heroSubtitle}>
              <Link className={styles.heroLink} to="/">
                {t("about.home")}
              </Link>
              <span> - </span>
              <span className={styles.secondaryColor}>{t("about.title")}</span>
            </h6>
          </div>
        </div>
      </div>

      <section className={`${styles.mainSection} container my-5`}>
        <div className={`row ${styles.contentRow}`}>
          <div className="col-md-12 col-lg-6 mb-3">
            <h1 className={styles.mainTitle}>
              {aboutData?.main_title || t("about.heading")}
            </h1>
            <span>
            <img
              src={aboutData?.logo || "assets/imgs/Frame 1410103777.svg"}
              className={styles.contentLogo}
              alt="About Us"
            />            </span>
            <p className={styles.mainDescription}>
              {aboutData?.main_description || t("about.subheading")}
            </p>

            <div className={styles.statsGrid}>
              <div className={styles.statsRow}>
                <div className={styles.statItem}>
                  <h5 className={styles.statTitle}>{aboutData?.title_one || t("about.years")}</h5>
                  <p className={styles.statDescription}>{aboutData?.description_one || t("about.yearsDesc")}</p>
                </div>
                <div className={styles.statItem}>
                  <h5 className={styles.statTitle}>{aboutData?.title_two || t("about.students")}</h5>
                  <p className={styles.statDescription}>{aboutData?.description_two || t("about.studentsDesc")}</p>
                </div>
              </div>

              <div className={styles.statsRow}>
                <div className={styles.statItem}>
                  <h5 className={styles.statTitle}>{aboutData?.title_three || t("about.years")}</h5>
                  <p className={styles.statDescription}>{aboutData?.description_three || t("about.yearsDesc")}</p>
                </div>
                <div className={styles.statItem}>
                  <h5 className={styles.statTitle}>{aboutData?.title_four || t("about.students")}</h5>
                  <p className={styles.statDescription}>{aboutData?.description_four || t("about.studentsDesc")}</p>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-12 col-lg-6 mb-3">
            <img
              src={aboutData?.image || "assets/imgs/Frame 1410103777.svg"}
              className={styles.contentImage}
              alt="About Us"
            />
          </div>
        </div>
      </section>

      <section className={styles.servicesSection}>
        <div className="container my-5">
          <h3 className={styles.servicesTitle}>{t("about.ourService")}</h3>

          <div className={styles.servicesContainer}>
            {[ 
              { img: "assets/imgs/Branding.svg", name: t("about.branding") },
              { img: "assets/imgs/Ui Design.svg", name: t("about.ui") },
              { img: "assets/imgs/Product.svg", name: t("about.product") },
            ].map((service, index) => (
              <div key={index} className={styles.serviceItem}>
                <img src={service.img} alt="" className={styles.serviceIcon} />
                <h4 className={styles.serviceName}>{service.name}</h4>
                <p className={styles.serviceDescription}>{t("about.serviceDesc")}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <TrustedCompanies />
    </>
  );
}
